// extracted by mini-css-extract-plugin
module.exports = {"link":"jgp-1jGUF","mini":"jgp-3D5i3","image":"jgp-6elBN"};